import { motion } from 'framer-motion';
import './Layout.css';
import bowl from './ramen_corrected.png';
import Navbar from './navbar.js';
import SiteCounter from './SiteCounter.js';

const Layout = ({ isPortrait }) => {

    const v1 = {
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
    };

    // Animation variants for the symbol-text pair
    const v2 = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { delay: 0.5 } }, // Delayed to start after text
    };

    const v3 = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { delay: 1 } }, // Delayed to start after text
    };

    const GoToGoogleMaps = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.open('https://maps.app.goo.gl/W6J6kBsP7hZrN5GX7', '_blank');
    };

    return (
        <div>
            <div className="layout">
            <img src={bowl} className={` ${isPortrait ? 'image' : 'image-landscape'}`} />
                <div className='title' />
                <SiteCounter />
                <div className={`body ${isPortrait ? '' : 'body-landscape'}`}>
                    <motion.div
                        initial="hidden"
                        animate="visible"
                        variants={v1}
                        transition={{ duration: 0.5 }}
                        style={{ zIndex: '3' }}
                    >
                        <h1 className={isPortrait ? '' : 'h1-landscape'}>
                            This is not a Ramen shop.
                        </h1>
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        animate="visible"
                        variants={v2}
                        transition={{ duration: 0.5 }}
                        className='hours-section'>
                        <h4 className={`hours ${isPortrait ? '' : 'h4-landscape'}`}>
                            Wednesday - Friday
                        </h4>
                        <h4 className={`hours ${isPortrait ? '' : 'h4-landscape'}`}>
                            4:30-9:30pm
                        </h4>
                        <h4 className={`hours ${isPortrait ? '' : 'h4-landscape'}`}>
                            Saturday
                        </h4>
                        <h4 className={`hours ${isPortrait ? '' : 'h4-landscape'}`}>
                            12:00pm-2:00pm
                        </h4>
                        <h4 className={`hours ${isPortrait ? '' : 'h4-landscape'}`}>
                            4:30-9:30pm
                        </h4>
                        <h4 className={`hours ${isPortrait ? '' : 'h4-landscape'}`}>
                            Sunday
                        </h4>
                        <h4 className={`hours ${isPortrait ? '' : 'h4-landscape'}`}>
                            11:30am - 4pm
                        </h4>
                        <motion.h4
                            className={`canclick ${isPortrait ? '' : 'h4-landscape'}`}
                            initial="hidden"
                            animate="visible"
                            variants={v3}
                            transition={{ duration: 1 }}
                            onClick={(e) => GoToGoogleMaps(e)}>
                            Porter Square, Cambridge MA
                        </motion.h4>
                    </motion.div>
                </div>


                

            </div>

            <Navbar isPortrait={isPortrait} />
        </div>
    );
};

export default Layout;